module.exports = __webpack_public_path__ + "static/media/desk.83860ba2.png";